const initCardDeckMobileSlider = () => {
    const sliderArray = document.querySelectorAll("[data-mobile-slider]");
    sliderArray.forEach(slider => {
        if (slider.getAttribute("data-mobile-slider").toLowerCase() === "true" && document.documentElement.clientWidth <= 768) {
            new Flickity(slider, {
                // options
                cellAlign: 'center',
                contain: true,
                autoPlay: true,
                prevNextButtons: false,
                pageDots: false,
            });
            //set height of every card to tallest card's height
            slider.querySelectorAll(".card").forEach(card => {
                card.classList.add("h-100");
            });
        }
    });
};
